module.exports = __webpack_public_path__ + "static/media/health-science-logo-uth.2520b68a.svg";